import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import get from 'lodash/get';

import Front from './Front';
import Tipping from './tipping/containers/Tipping';
import AppointmentTipping from './tipping/containers/AppointmentTipping';
import * as hooks from '../auth/routerHooks';
import Receipt from './receipts/containers/Receipt';
import ReceiptSent from './receipts/containers/ReceiptSent';

const onChange = (prevState, nextState, replace) => {
  if (get(prevState, 'location.query.listening') && !get(nextState, 'location.query.listening')) {
    const newQuery = get(nextState, 'location.query');
    const newLocation = Object.assign({}, nextState.location, { query: { ...newQuery, listening: true } });
    replace(newLocation);
  }
};

export default store => (
  <Route path="/customer" onEnter={hooks.requireAuth(store)} onChange={onChange}>
    <IndexRoute component={Front} />
    <Route path="tip" component={Tipping} />
    <Route path="tip/:appointmentId" component={AppointmentTipping} />
    <Route path="receipt/:transactionIdentifier" component={Receipt} />
    <Route path="receipt-sent/:type" component={ReceiptSent} />
  </Route>
);
